import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const ElectoralCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Certificazione Elettorale',
    path: '/sportello/elettorale',
  },
];

export const ElectoralANPRCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Certificazione ANPR Elettorale',
    path: '/sportello/elettorale-anpr',
  },
];
